import classNames from 'classnames';
import { IconNameV2, IconV2 } from 'common/icon/iconV2.js';
import { ICheckedFilter } from 'types/location.js';

export interface LegendsFilterToggleProps {
  filters: ICheckedFilter[];
  idx: number;
  className?: string;
  checkboxFilterOnClick(f: ICheckedFilter | 'all' | 'none'): void;
}

const getNextState = (state: 'all' | 'some' | 'none'): 'all' | 'none' => {
  switch (state) {
    case 'all':
      return 'none';
    case 'none':
      return 'all';
    case 'some':
      return 'all';
  }
};

export const LegendsFilterToggle = ({
  filters,
  idx,
  className,
  checkboxFilterOnClick: onCheckFilter,
}: LegendsFilterToggleProps) => {
  // const { icon, label, selected, key } = filter;
  const filterLabelId = `checkbox-${idx}`;
  const state = filters.every((f) => f.selected) ? 'all' : filters.every((f) => !f.selected) ? 'none' : 'some';
  const lib: Record<'all' | 'some' | 'none', IconNameV2 | undefined> = {
    all: 'check',
    some: 'subtract',
    none: undefined,
  };
  const iconName = lib[state];

  const nextState = getNextState(state);

  return (
    <label htmlFor={filterLabelId} className={classNames('Checkbox', className)} key={idx}>
      <input
        id={filterLabelId}
        className="Checkbox-input"
        type="checkbox"
        checked={state === 'all'}
        onChange={() => onCheckFilter(nextState)}
      />
      <div className="Checkbox-label u-flex u-flexRow u-flexAlignItemsCenter">
        <small className="flex-1 u-widthFull">All filters</small>
        {iconName ? (
          <div className="svg--font-inline svg-background-link u-textWhite svg--fill-inherit">
            <IconV2 size={16} icon={iconName} />
          </div>
        ) : (
          <div
            className="svg-color-stroke--hover u-flex u-textWhite"
            style={{
              borderWidth: '1px',
              borderStyle: 'solid',
              borderRadius: '2px',
            }}
          >
            <div
              style={{
                height: '14px',
                width: '14px',
              }}
            />
          </div>
        )}
      </div>
    </label>
  );
};
